import { Address } from './Address';
import { EmploymentData } from './employmentVerification';
import { ScreeningInvite } from './screeningInvite';

export class Demographics
{
    firstName : string;
    lastName : string;
    middleName: string;
    ssn : string;
    dob : Date;
    street : string;
    city : string;
    state : string;
    zipCode : number;
    employmentData : EmploymentData;
    clientLocationId : number;
    monthlyIncome : number;
    userId : number;

    invitation: ScreeningInvite;
}